import { getImage } from 'gatsby-plugin-image';
import React from 'react';
import { ArticlePreview } from '../components/ArticlePreview/ArticlePreview';

export const createArticlePreviewCards = (
    nodes: any,
    recommended?: boolean
) => {
    return nodes.map((article, idx) => {
        let size: `sm` | `md` | `lg` = recommended ? `md` : `sm`;
        if (recommended && idx === 0) {
            size = `lg`;
        }
        const {
            field_article_title,
            field_subtitle,
            relationships: summaryRel,
            field_external_link,
        } = article.relationships?.field_summary;

        const title = field_article_title.replaceAll(`**`, ``);
        return (
            <ArticlePreview
                key={idx}
                size={size}
                title={title}
                summary={field_subtitle}
                link={field_external_link ?? article.fields?.url}
                categoryName={summaryRel.field_category?.name}
                categoryLink="/learn"
                image={getImage(
                    summaryRel.field_image?.relationships?.field_media_image
                        ?.localFile
                )}
            />
        );
    });
};
